import FocusShell from "../components/FocusShell";
import Estimator from "../components/Estimator";

export default function EstimateCalculator() {
  return (
    <FocusShell
      testid="estimate-calculator-page"
      title="Curtain Price Calculator | Reef Deco — Dubai"
      description="Get an instant price estimate for curtains and blinds in Dubai. Enter your window sizes, pick a fabric, and see your price in seconds."
    >
      <Estimator />
    </FocusShell>
  );
}
